import ApiService from "@/services/api.service";

const state = {
  projects: [],
  project: {},
  projectStates: {},
};

const getters = {
  getProjects(state) {
    return state.projects;
  },
  getProject(state) {
    return state.project;
  },
  getProjectStates(state) {
    return state.projectStates;
  },
};

const actions = {
  fetchProjects({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getprojects/", { ...payload })
        .then(({ data }) => {
          commit("setProjects", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchProject({ commit }, payload) {
    let params = {
      id: payload,
    };
    if (typeof payload === "object") {
      params = payload;
    }
    return new Promise((resolve) => {
      ApiService.post("getprojectbyid/", params)
        .then(({ data }) => {
          commit("setProject", data);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },

  fetchProjectStates({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getconfigs/")
        .then(({ data }) => {
          commit("setProjectStates", data.project_states);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
};

const mutations = {
  setProjects(state, payload) {
    state.projects = payload;
  },
  setProject(state, payload) {
    state.project = payload;
  },
  setProjectStates(state, payload) {
    state.projectStates = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
